import { combineReducers } from 'redux';
import { fromJS } from 'immutable';
import getApiReducer from '../common/utils/getApiReducer';

import {
  ADD_RESPONSE_VIDEO_TO_SUBMITTAL,
  FETCH_SUBMITTALS_HISTORY,
  FETCH_SUBMITTALS_PENDING_REVIEW,
  FETCH_SUBMITTALS_PENDING_REVIEW_COUNT,
  GET_RESPONSE_VIDEO_FOR_COMPLETED_SUBMITTAL,
  GET_RESPONSE_VIDEO_FOR_PENDING_SUBMITTAL,
  SUBMIT_SWING_REVIEW,
  UPLOAD_SUBMITTAL_REPLY_VIDEO,
  UPLOAD_SUBMITTAL_REPLY_VIDEO_PROGRESS,
} from './actions';

const swingResponseUploading = (state = false, action) => {
  if (action.type === UPLOAD_SUBMITTAL_REPLY_VIDEO) {
    state = action.uploading;
  }
  return state;
};

const swingResponseUploadProgress = (state = { loaded: 0, total: 100 }, action) => {
  if (action.type === UPLOAD_SUBMITTAL_REPLY_VIDEO_PROGRESS) {
    state = { loaded: action.loaded, total: action.total };
  }
  return state;
};

const pendingReviewReducer = getApiReducer(FETCH_SUBMITTALS_PENDING_REVIEW);
const pendingReview = (state, action) => {
  state = pendingReviewReducer(state, action);

  if (action.type === `${ADD_RESPONSE_VIDEO_TO_SUBMITTAL}_SUCCESS`) {
    const index = state.get('data').findIndex(item => item.get('id') === action.json.id);

    return state.setIn(['data', index], fromJS(action.json));
  }

  if (action.type === `${GET_RESPONSE_VIDEO_FOR_PENDING_SUBMITTAL}_SUCCESS`) {
    const index = state.get('data').findIndex(item => item.get('id') === parseInt(action.submittalId, 10));

    return state.setIn(['data', index, 'response'], fromJS(action.json));
  }

  if (action.type === `${SUBMIT_SWING_REVIEW}_SUCCESS`) {
    const index = state.get('data').findIndex(item => item.get('id') === parseInt(action.submittalId, 10));

    return state.deleteIn(['data', index]);
  }

  return state;
};

const historyReducer = getApiReducer(FETCH_SUBMITTALS_HISTORY);
const history = (state, action) => {
  state = historyReducer(state, action);

  if (action.type === `${GET_RESPONSE_VIDEO_FOR_COMPLETED_SUBMITTAL}_SUCCESS`) {
    const index = state
      .getIn(['data', 'results'])
      .findIndex(item => item.get('id') === parseInt(action.submittalId, 10));

    return state.setIn(['data', 'results', index, 'response'], fromJS(action.json));
  }

  return state;
};

const pendingReviewCountReducer = getApiReducer(FETCH_SUBMITTALS_PENDING_REVIEW_COUNT);
const pendingReviewCount = (state, action) => {
  state = pendingReviewCountReducer(state, action);

  if (action.type === `${SUBMIT_SWING_REVIEW}_SUCCESS`) {
    return state.setIn(['data', 'count'], state.getIn(['data', 'count']) - 1);
  }

  return state;
};

export default combineReducers({
  pendingReviewCount,
  pendingReview,
  history,
  submitSwingReview: getApiReducer(SUBMIT_SWING_REVIEW),
  swingResponseUploading,
  swingResponseUploadProgress,
});



// WEBPACK FOOTER //
// ./src/swing-submittals/reducers.js